import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ActionButton from '@themes/account/components/ActionButton';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import DiscountIcon from '@mui/icons-material/Discount';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GetAccountSettings } from '@themes/common/data';
const { customers_pdf_download, customers_pdf_view } = GetAccountSettings().translations;
export const AccountDiscountWrapper = styled((props) => _jsx(Paper, Object.assign({}, props, { elevation: 0 })))(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    width: '200px',
    borderRadius: 0,
}));
export const DiscountImage = styled((props) => (_jsx("div", { className: 'image-cover cover-loaded aspect-ratio--1-1', style: {
        backgroundImage: `url(${props.src})`,
    } })))(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
}));
export const DiscountName = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginTop: theme.spacing(1),
}));
const AccountDiscountCard = ({ discountCategory }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const title = (_a = discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.fields.find((field) => field.key === 'title')) === null || _a === void 0 ? void 0 : _a.value;
    const file = discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.fields.find((field) => field.key === 'file');
    const link = (_b = discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.fields.find((field) => field.key === 'link')) === null || _b === void 0 ? void 0 : _b.value;
    const image = (_e = (_d = (_c = discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.fields.find((field) => field.key === 'image')) === null || _c === void 0 ? void 0 : _c.reference) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.url;
    const fileUrl = link || ((_f = file === null || file === void 0 ? void 0 : file.reference) === null || _f === void 0 ? void 0 : _f.url);
    const imagePreview = image || ((_j = (_h = (_g = file === null || file === void 0 ? void 0 : file.reference) === null || _g === void 0 ? void 0 : _g.preview) === null || _h === void 0 ? void 0 : _h.image) === null || _j === void 0 ? void 0 : _j.url);
    const handleDownload = useCallback(() => {
        if (fileUrl) {
            const fileName = `${discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.description}.pdf`;
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.download = fileName;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            anchor.remove();
        }
    }, [discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.description, fileUrl]);
    const handlePreview = useCallback(() => {
        if (fileUrl) {
            globalThis.open(fileUrl, '_blank');
        }
    }, [fileUrl]);
    return (_jsxs(Stack, Object.assign({ spacing: 1, sx: { width: '200px' } }, { children: [_jsxs(AccountDiscountWrapper, { children: [imagePreview ? _jsx(DiscountImage, { src: imagePreview }) : _jsx(DiscountIcon, { sx: { width: '100%', height: '150px' } }), _jsx(DiscountName, { children: title || (discountCategory === null || discountCategory === void 0 ? void 0 : discountCategory.description) })] }), fileUrl && (_jsxs(Stack, Object.assign({ direction: 'column', spacing: 1 }, { children: [_jsx(ActionButton, Object.assign({ endIcon: _jsx(DownloadIcon, {}), onClick: handleDownload, loadingPosition: 'end', sx: { width: '200px' } }, { children: customers_pdf_download })), _jsx(ActionButton, Object.assign({ endIcon: _jsx(VisibilityIcon, {}), onClick: handlePreview, loadingPosition: 'end', sx: { width: '200px' } }, { children: customers_pdf_view }))] })))] })));
};
export default AccountDiscountCard;
